import type { SupabaseClient } from '@supabase/supabase-js';

export const CUSTOMER_DISPLAY_BANNERS_BUCKET = 'customer-display-banners';
const MAX_BANNER_BYTES = 2 * 1024 * 1024;
const ALLOWED_EXT = new Set(['jpg', 'jpeg', 'png', 'webp', 'gif']);

export async function uploadCustomerDisplayBanner(
  supabase: SupabaseClient,
  clientId: string,
  slot: number,
  file: File,
): Promise<string> {
  if (!file.type.startsWith('image/')) {
    throw new Error('Please choose an image file (JPEG, PNG, WebP, or GIF).');
  }
  if (file.size > MAX_BANNER_BYTES) {
    throw new Error('Image must be 2 MB or smaller.');
  }

  const rawExt = file.name.split('.').pop()?.toLowerCase() ?? '';
  const ext = ALLOWED_EXT.has(rawExt) ? rawExt.replace('jpeg', 'jpg') : 'jpg';
  const path = `${clientId}/banner-${slot + 1}-${Date.now()}.${ext}`;

  const { error } = await supabase.storage
    .from(CUSTOMER_DISPLAY_BANNERS_BUCKET)
    .upload(path, file, { contentType: file.type, upsert: false });
  if (error) throw new Error(error.message);

  const { data } = supabase.storage.from(CUSTOMER_DISPLAY_BANNERS_BUCKET).getPublicUrl(path);
  if (!data.publicUrl) throw new Error('Upload succeeded but public URL is missing.');
  return data.publicUrl;
}
